/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import {
    OptionProps,
    MenuProps,
    OptionTypeBase,
    OptionsType,
    ValueContainerProps,
    components
} from "react-select";
import i18next from "i18next";
import Checkbox from "../FormElements/Checkbox";
import { MultiSelectBottomHeader } from "./styles";

export const ValueContainer = (props: ValueContainerProps<OptionTypeBase>): JSX.Element => {
    const { children, options } = props;
    const firstElement = React.Children.toArray(children);
    const itemsSelected = (): string => {
        const labels = options.map((option) => option.label);
        const optionsLength = labels.includes("hidden")
            ? firstElement.length - 2
            : firstElement.length - 1;

        if (
            (firstElement[0] as Record<string, string>).key.includes("placeholder") ||
            (firstElement.length === 2 && labels.includes("hidden"))
        ) {
            return i18next.t("Select Options");
        }

        if (options.length === firstElement.length - 1 && !options[0]?.options?.length) {
            return i18next.t("All Selected");
        }

        return `${optionsLength} ${i18next.t("Selected")}`;
    };

    return (
        <components.ValueContainer {...props}>
            {itemsSelected()}
            {firstElement[firstElement.length - 1]}
        </components.ValueContainer>
    );
};

export const Option = (props: OptionProps<OptionTypeBase>): JSX.Element => {
    const { children, data, isSelected } = props;

    return (
        <div title={data.label}>
            <components.Option {...props}>
                <div className="d-flex align-items-center">
                    <Checkbox containerClassName="m-0" selected={isSelected} />
                    {children}
                </div>
            </components.Option>
        </div>
    );
};

export const Menu = (props: MenuProps<OptionTypeBase>): JSX.Element => {
    const {
        children,
        selectProps: { selectAllHandleClick, isMulti, value, isOptionDisabled, shouldDisable },
        options: selectOptions
    } = props;

    return (
        <components.Menu {...props}>
            <>
                <div className="d-flex flex-column overflow-auto">{children}</div>

                {isMulti && (
                    <MultiSelectBottomHeader>
                        <button
                            className="select-all"
                            disabled={
                                !value ||
                                (value as OptionsType<OptionTypeBase>).length ===
                                    selectOptions.length ||
                                (shouldDisable && !(value as OptionsType<OptionTypeBase>).length)
                            }
                            type="button"
                            onClick={(): void => {
                                if (
                                    selectOptions[0] &&
                                    selectOptions[0].options &&
                                    selectOptions[0].options.length
                                ) {
                                    const opt: any = [];

                                    selectOptions.forEach((option) => {
                                        option.options.forEach((i: any) => {
                                            if (
                                                isOptionDisabled &&
                                                !isOptionDisabled(i, option as any)
                                            ) {
                                                opt.push(i);
                                            }
                                        });
                                    });
                                    if (opt.length !== value?.length) {
                                        selectAllHandleClick(opt);
                                    }
                                } else {
                                    selectAllHandleClick(selectOptions);
                                }
                            }}
                        >
                            {i18next.t("Select All")}
                        </button>
                        <button
                            className="clear-all"
                            disabled={
                                value ? (value as OptionsType<OptionTypeBase>).length === 0 : true
                            }
                            type="button"
                            onClick={(): void => props.clearValue()}
                        >
                            {i18next.t("Clear All")}
                        </button>
                    </MultiSelectBottomHeader>
                )}
            </>
        </components.Menu>
    );
};
